<template>
  <div v-if="quoteFreight.logistic_provider.delivery_methods.length > 0">
    <h2 class="subtitle has-text-weight-bold has-text-primary is-size-4">
        Opções de Envio ({{ quoteFreight.logistic_provider.delivery_methods.length }})
    </h2>
    <div class="columns sc-delivery-options-column">
      <div class="column is-4" v-for="(deliveryMethod, deliveryMethodKey) in quoteFreight.logistic_provider.delivery_methods" :key="deliveryMethodKey">
        <sc-card>
          <template slot="header">
            <p class="has-text-primary is-size-6 card-header-title">
              {{ deliveryMethod.name }}
            </p>
          </template>
          <template slot="body">
            <div class="columns">
              <div class="column">
                <p class="heading" v-if="deliveryMethod.name">
                  <strong>Método de envio:</strong>
                  <span>{{ deliveryMethod.name }}</span>
                </p>
                <p class="heading" v-if="deliveryMethod.description">
                  <strong>Nome exibido:</strong>
                  <span>{{ deliveryMethod.description }}</span>
                </p>
                <p class="heading" v-if="deliveryMethod.type.label">
                  <strong>Tipo de Método:</strong>
                  <span>{{ deliveryMethod.type.label }}</span>
                </p>
                <p class="heading">
                  <strong>Frete exibido:</strong>
                  <span>{{ deliveryMethod.final_shipping_cost | currency }}</span>
                </p>
                <p class="heading" v-if="(deliveryMethod.delivery_estimate_minutes || deliveryMethod.delivery_estimate_minutes === 0 ) || (deliveryMethod.delivery_estimate_business_days || deliveryMethod.delivery_estimate_business_days === 0)">
                  <strong>Prazo de entrega:</strong>
                  <span>{{ deliveryMethod.delivery_estimate_minutes || deliveryMethod.delivery_estimate_minutes === 0 ? `${deliveryMethod.delivery_estimate_minutes} minuto(s)` : `${deliveryMethod.delivery_estimate_business_days} dia(s)` }}</span>
                </p>
                <p class="heading" v-if="deliveryMethod.delivery_estimate_date_minutes_iso">
                  <strong>Data prevista da entrega:</strong>
                  <span>{{ Moment(deliveryMethod.delivery_estimate_date_minutes_iso).format('L') +' ÀS '+Moment(deliveryMethod.delivery_estimate_date_minutes_iso).format('LT')}}</span>
                </p>
                <p class="heading" v-if="deliveryMethod.cost">
                  <strong>Custo de envio:</strong>
                  <span>{{ deliveryMethod.cost | currency }}</span>
                </p>
              </div>
              <div class="column is-narrow">
                <figure class="image is-128x128">
                  <img :src="deliveryMethod.logo_url" :alt="deliveryMethod.name" />
                </figure>
                <a v-if="quoteFreight.id" :href="`/ng#/recote/${quoteFreight.id}/${deliveryMethod.id}?msg=false&url=${backUrl}&logisticContractMode=${logistic_contract_mode}&reverse=${shipment_type}`" class="button is-primary" target="_blank">
                        Cotação Detalhada
                    </a>
                <a v-else @click="getDetail(deliveryMethod)" href="javascript:void(0)" class="button is-primary">
                        Cotação Detalhada
                    </a>
              </div>
            </div>
          </template>
        </sc-card>
      </div>
    </div>
    <hr/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScCard } from '@intelipost-js/secure-components';
import { Moment, Storage } from '@intelipost-js/secure-providers';

const { mapState } = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-delivery-options',
  props: {
    fields: Object,
  },
  data() {
    return {
      Moment,
      backUrl: window.location.href,
    };
  },
  computed: {
    ...mapState([
      'quoteFreight',
      'logistic_contract_mode',
      'shipment_type',
    ]),
  },
  methods: {
    getDetail(dm) {
      const originStorage = Storage.get('persistData', 'local') || 'session';
      const id = Math.floor(Date.now() / 1000);
      const { volumes, products } = this.fields;

      const itens = volumes !== undefined ? volumes : products;

      const obj = {
        content: {
          origin_zip_code: this.fields.origin_zip_code,
          destination_zip_code: this.fields.destination_zip_code,
          delivery_options: [dm],
          volumes: itens.map((v) => {
            const fixParams = {
              volume_type: 'BOX',
              product_category: null,
              description: null,
              sku_groups_ids: null,
            };
            return Object.assign(v, fixParams);
          }),
        },
      };

      sessionStorage.setItem(id, JSON.stringify(obj));
      if (originStorage === 'session') {
        window.location.href = `/ng#/recote/${id}/${dm.id}?msg=false&url=${window.location.href}&logisticContractMode=${this.logistic_contract_mode}&reverse=${this.shipment_type}`;
      } else {
        window.open(`/ng#/recote/${id}/${dm.id}?msg=false&url=${window.location.href}&logisticContractMode=${this.logistic_contract_mode}&reverse=${this.shipment_type}`, '_blank');
      }
    },
  },
  components: {
    ScCard,
  },
};
</script>

<style lang="scss" scoped>
.sc-delivery-options-column {
  flex-flow: row wrap;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-delivery-options/ScDeliveryOptions.vue